import http from './http.js'
const resquest = 'https://yunzhixuanpro.fw366.cn/api/'
// const resquest = 'http://192.168.0.194/api'
import qs from 'qs'
export default {
  careerTypeList(params) {
    return http.post(`career-type-list`, params)
  },
  articleRecommendCate(params) {
    return http.post(`article-recommend-cate`, params)
  },
  userOrderPaid(params) {
    return http.post(`user-order-paid`, params)
  },
  walletFlow(params) {
    return http.post(`wallet-flow`, params)
  },
  orderPackList(params) {
    return http.post(`order-pack-list`, params)
  },
  majorSubjectSearchSchoolList(params) {
    return http.post(`major-subject-search-school-list`, params)
  },
  teacherIntentionList(params) { //子账户志愿列表
    return http.post(`teacher-intention-list`, params)
  },
  intentionLock(params) { //锁定/解锁志愿
    return http.post(`teacher-intention-lock`, params)
  },
  userBalance(params) {
    return http.post(`user-balance`, params)
  },
  intentionRrintCount(params) {
    return http.post(`intention-print-count`, params)
  },
  teacherBindList(params) {
    return http.post(`teacher-bind-list`, params)
  },
  teacherSearchUser(params) {
    return http.post(`teacher-search-user`, params)
  },
  teacherBindUserRequest(params) {
    return http.post(`teacher-bind-user-request`, params)
  },
  teacherBindUserCheck(params) {
    return http.post(`teacher-bind-user-check`, params)
  },
  teacherShiftLogin(params) {
    return http.post(`teacher-shift-login`, params)
  },
  intentionCheck(params) {
    return http.post(`intention-check`, params)
  },
  userExamInfoSet(params) {
    return http.post(`user-exam-info-set`, params)
  },
  subjectSearchByScore(params) {
    return http.post(`major-subject-search-by-score`, params)
  },
  majorCareers(params) {
    return http.post(`major-careers`, params)
  },
  subjectByMajor(params) {
    return http.post(`major-subject-search-by-major`, params)
  },
  subjectByCareer(params) {
    return http.post(`major-subject-search-by-career`, params)
  },
  userExamScoreDetail(params) {
    return http.post(`user-exam-score-detail`, params)
  },
  customCheckList(params) {
    return http.post(`custom-check-list`, params)
  },
  schoolRankOthers(params) {
    return http.get(`school-rank-others`, params)
  },
  majorSubjectSearch(params) {
    return http.post(`major-subject-search`, params)
  },
  friendLink(params) {
    return http.get(`friend-link`, params)
  },
  careerList(params) {
    return http.post(`career-list`, params)
  },
  careerDetail(params) {
    return http.post(`career-detail`, params)
  },
  intentionDelete(params) {
    return http.post(`intention-delete`, params)
  },
  userExamScoreAdd(params) {
    return http.post(`user-exam-score-add`, params)
  },
  userExamInfo(params) {
    return http.get(`user-exam-score-add`, params)
  },
  customCheckList(params) {
    return http.post(`custom-check-list`, params)
  },
  aiIntentionMake(params) {
    return http.post(`ai-intention-make`, params)
  },
  getCustomSearch(params) {
    return http.get(`check-school-custom-search`, params)
  },

  inventionSchoolAdd(params) {
    return http.post(`invention-school-add`, params)
  },
  userExamScoreHistory(params) {
    return http.get(`user-exam-score-history`, params)
  },
  inventionMajorDelete(params) {
    return http.post(`invention-major-delete`, params)
  },
  inventionSchoolDel(params) {
    return http.post(`invention-school-delete`, params)
  },
  inventionMajorAdd(params) {
    return http.post(`invention-major-add`, params)
  },
  indexRecommend(params) {
    return http.post(`index-recommend`, params)
  },
  customSchoolOption(params) {
    return http.get(`custom-school-option`, params)
  },
  subjectTypeList(params) {
    return http.get(`subject-type-list`, params)
  },
  getIndexRecommend(params) {
    return http.get(`index-recommend`, params)
  },
  getLocations(params) {
    return http.post(`https://apis.map.qq.com/ws/location/v1/ip`, params)
  },
  schoolMarkLlist(params) {
    return http.post(`school-mark-list`, params)
  },
  hotRankMajor(params) {
    return http.get(`hot-rank-major`, params)
  },
  majorMarkLlist(params) {
    return http.post(`major-mark-list`, params)
  },
  majorMark(params) {
    return http.post(`major-mark`, params)
  },
  hotRankSchool(params) {
    return http.get(`hot-rank-school`, params)
  },
  banner(params) {
    return http.get('app-content', params);
  }, //反馈类型
  areaList(params) {
    return http.get('province-available-list', params);
  }, //获取地区下拉列表
  userInfo(params) {
    return http.post('user-info', params);
  }, //获取用户信息
  typeList(params) {
    return http.get('subject-type-list', params);
  }, //获取高考模式
  walFlow(params) {
    return http.post('wal-flow', params);
  }, //积分流水
  userReportLabels(params) {
    return http.get('user-report-labels');
  }, //反馈类型
  userReport(params) {
    return http.post('user-report', params);
  }, //用户提交反馈
  userReportDetail(params) {
    return http.get('user-report-detail', params);
  }, //用户反馈详情
  userReportList(params) {
    return http.get('user-report-list', params);
  }, //反馈记录列表
  addressAdd(params) {
    return http.post('user-address-add', params);
  }, //新增地址
  addressEdit(params) {
    return http.post('user-address-edit', params);
  }, //修改地址
  addressDel(params) {
    return http.post('user-address-del', params);
  }, //删除地址
  getUserInfo(params) {
    return http.get('user-info', params);
  }, //修改个人信息
  userAddressList(params) {
    return http.get('user-address-list');
  }, //地址列表
  usersign(params) {
    return http.get('user-sign');
  }, //签到
  userSignWeek(params) {
    return http.get('user-sign-week');
  }, //本周签到记录
  cateList(params) {
    return http.get('practice-cate-list');
  }, //习题分类
  practice(params) {
    return http.get('practice-cate-test', params);
  }, //获取分类随机题目列表
  star(params) {
    return http.post('practice-star', params);
  }, //收藏题目
  submit(params) {
    return http.post('practice-submit-one', params);
  }, //提交练习题答案
  practiceResult(params) {
    return http.get('practice-result', params);
  }, //获取练习结果
  favorList(params) {
    return http.get('question-favor-list', params);
  }, //获取题目收藏夹列表
  wrongList(params) {
    return http.get('question-wrong-list', params);
  }, //获取错题本列表
  questionTypeSelect(params) {
    return http.get('question-type-select', params);
  }, //题型下拉列表
  questionCateSelect(params) {
    return http.get('question-cate-select', params);
  }, //题目分类下拉列表
  wrongCorrect(params) {
    return http.post('question-wrong-correct', params);
  }, //错题提交
  appContent(params) {
    return http.get('app-content', params);
  }, //错题提交
  userMissionList(params) {
    return http.get('user-mission-list', params);
  }, //任务列表
  userMissionReward(params) {
    return http.post('user-mission-reward', params);
  }, //领取任务奖励
  passageDetail(params) {
    return http.get('passage-detail', params);
  }, //获取阅读理解相关材料
  goodsList(params) {
    return http.get('shop-goods-list', params);
  }, //获取商品列表
  goodsDetail(params) {
    return http.get('shop-goods-detail', params);
  }, //商品详情
  shopPreorder(params) {
    return http.post('shop-preorder', params);
  }, //订单准备页数据请求
  addressDefault(params) {
    return http.get('user-address-default', params);
  }, //订单准备页数据请求
  createOrder(params) {
    return http.post('shop-order-create', params);
  }, //创建订单
  orderList(params) {
    return http.post('shop-order-list', params);
  }, //获取订单列表
  userBalance(params) {
    return http.post('user-balance', params);
  }, //钱包余额
  orderCancel(params) {
    return http.post('shop-order-cancel', params);
  }, //取消订单
  orderContinue(params) {
    return http.post('shop-order-continue', params);
  }, //继续支付
  orderConfirm(params) {
    return http.post('shop-order-confirm', params);
  }, //确认收货
  askInvoice(params) {
    return http.post('shop-order-invoice-ask', params);
  }, //索要发票
  miniAuth(params) {
    return http.post('mini-auth', params);
  }, //小程序授权
  miniBind(params) {
    return http.post('mini-bind', params);
  }, //微信小程序绑定账号
  exam(params) {
    return http.get('practice-exam', params);
  }, //获取综合测试题目列表
  examList(params) {
    return http.get('practice-exam-list', params);
  }, //综合测试模板列表
  examNew(params) {
    return http.post('practice-exam-new', params);
  }, //生成新的综合测试试卷
  examRecord(params) {
    return http.get('practice-exam-record', params);
  }, //综合测试记录列表
  examDee(params) {
    return http.post('practice-exam-dee', params);
  }, //删除综合测试记录
  examPdf(params) {
    return http.post('practice-exam-pdf', params);
  }, //综合测试试卷生成pdf
  // new
  index(params) {
    return http.get('index?pc=1', params);
  }, //首页内容
  schoolList(params) {
    return http.post('school-list', params);
  }, //学校列表
  schoolDetail(params) {
    return http.post('school-detail', params);
  }, //学校详情
  majorTypeList(params) {
    return http.post('major-type-list?pc=1', params);
  }, //专业分类列表
  majorDetail(params) {
    return http.post('major-detail', params);
  }, //专业详情
  majorList(params) {
    return http.post('major-list', params);
  }, //专业列表
  majorSchools(params) {
    return http.post('major-schools', params);
  }, //开设院校
  getList(params) {
    return http.get('school-list?pc=1', params);
  }, //筛选条件（侧拉栏）
  schoolSearch(params) {
    return http.post('school-search', params);
  }, //学校搜索
  schoolMajors(params) {
    return http.post('school-majors?pc=1', params);
  }, //学校内专业
  newsDetail(params) {
    return http.post('news-detail', params);
  }, //新闻详情
  caseDetail(params) {
    return http.post('case-detail', params);
  }, //案例详情
  provinceLine(params) {
    return http.get('province-line?pc=1', params);
  }, //省控线筛选
  provinceLine1(params) {
    return http.post('province-line?pc=1', params);
  }, //省控线数据
  provinceScore(params) {
    return http.post('province-score?pc=1', params);
  }, //省控线数据
  scoreHistory(params) {
    return http.post('score-history', params);
  }, //获取往年同位分
  schoolLine(params) {
    return http.post('school-line', params);
  }, //历年录取分数
  schoolGoal(params) {
    return http.post('school-goal', params);
  }, //目标分数获取学校列表
  scoreRank(params) {
    return http.post('score-rank', params);
  }, //根据分数获取位次
  majorSearch(params) {
    return http.post('major-search', params);
  }, //专业搜索
  checkSchoolSimulated(params) {
    return http.get('check-school-simulated', params);
  }, //模拟审核学校（获取配置）
  checkSchoolSimulatedSearch(params) {
    return http.get('check-school-simulated-search',
      params);
  }, //搜索批次内符合条件的学校
  SchoolSimulated(params) {
    return http.post('check-school-simulated', params);
  }, //专业搜索
  simulatedDetail(params) {
    return http.post('check-school-simulated-detail', params);
  }, //模拟审核学校结果详情
  checkMajorSimulatedMajorSearch(params) {
    return http.post('check-major-simulated-major-search',
      params);
  }, //模拟选专业（可选专业下拉）

  simulatedSearch1(params) {
    return http.post('check-major-simulated-search', params);
  }, //模拟选专业（搜索学校）
  check(params) {
    return http.post('check-major-simulated', params);
  }, //提交审核专业
  checkMajorSimulatedDetail(params) {
    return http.post('check-major-simulated-detail',
      params);
  }, //模拟审核专业结果详情
  search(params) {
    return http.get('check-school-simulated-search', params);
  },
  checkSchoolSimulatedList(params) {
    return http.post('check-school-simulated-list', params);
  }, //模拟审核学校结果列表
  checkMajorSimulatedList(params) {
    return http.post('check-major-simulated-list', params);
  },
  aiSchoolOptions(params) {
    return http.post('ai-school-options?pc=1', params);
  },
  aiSchoolAsk(params) {
    return http.post('ai-school-ask', params);
  }, //AI获取学校
  aiSchoolSet(params) {
    return http.get('ai-school-set', params);
  }, //AI选学校获取条件
  aiCheckList(params) {
    return http.post('ai-check-list', params);
  }, //智选志愿列表
  aiSchoolList(params) {
    return http.post('ai-school-list', params);
  }, //智选志愿列表
  aiChange(params) {
    return http.post('ai-school-change', params);
  }, //AI志愿新增/替换学校
  checkSchool(params) {
    return http.post('check-school', params);
  }, //提交审核学校
  schoolFake(params) {
    return http.get('school-fake', params);
  }, //野鸡大学名单
  schoolRank(params) {
    return http.get('school-rank', params);
  }, //学校排名
  aiMajorList(params) {
    return http.post('ai-major-list?pc=1', params);
  }, //学校排名
  aiMajorChange(params) {
    return http.post('ai-major-change', params);
  }, //AI志愿新增/替换专业
  checkRresultList(params) {
    return http.post('check-result-list', params);
  }, //审核结果列表
  checkResultDetail(params) {
    return http.post('check-result-detail', params);
  }, //审核结果列表
  del(params) {
    return http.post('check-cache-drop', params);
  }, //删除志愿
  customCheckList(params) {
    return http.post('custom-check-list', params);
  }, //人工志愿列表
  set(params) {
    return http.get('check-school-simulated', params);
  }, //模拟审核学校（获取配置）
  checkSchoolCustomSearch(params) {
    return http.post('check-school-custom-search', params);
  }, //模拟审核学校（获取配置）
  customSchoolNew(params) {
    return http.post('custom-school-new', params);
  }, //新增志愿
  customCheckDetail(params) {
    return http.post('custom-check-detail?pc=1', params);
  }, //查看志愿
  checkMajorCustomSearch(params) {
    return http.post('check-major-custom-search?pc=1', params);
  }, //学校内搜索专业
  smsCode(params) {
    return http.post('sms-code', params);
  }, //发送手机验证码
  loginCode(params) {
    return http.post('login-code', params);
  }, //手机验证码注册/登录
  loginPass(params) {
    return http.post('login-pass', params);
  }, //账号密码登录
  userPassSet(params) {
    return http.post('user-pass-set', params);
  }, //修改密码
  userShare(params) {
    return http.get('user-report-share', params);
  }, //分享链接
  schoolNewsDetail(params) {
    return http.post('school-news-detail', params);
  }, //分享链接
  aiMajorMmove(params) {
    return http.post('ai-major-move', params);
  }, //志愿专业上/下移
  schoolLineOption(params) {
    return http.post('school-line-option', params);
  }, //历年录取分数选项
  schoolRankScience(params) {
    return http.get('school-rank-science', params);
  }, //学校排名-软科
  schoolRankAlumni(params) {
    return http.get('school-rank-alumni', params);
  }, //学校排名-校友
  repassCode(params) {
    return http.post('repass-code', params);
  }, //手机验证码重置密码
  testMbtiQuestion(params) {
    return http.post('test-mbti-question?pc=1', params);
  }, //MBTI测试题目
  testMbtiResult(params) {
    return http.post('test-mbti-result', params);
  }, //MBTI测试结果
  Holland(params) {
    return http.post('test-holland-question', params);
  }, //Holland测试题目
  testHollandResult(params) {
    return http.post('test-holland-result', params);
  }, //Holland测试题目
  userActive(params) {
    return http.post('user-active', params);
  }, //用户激活卡
  userCompe(params) {
    return http.post('user-compe', params);
  }, //用户激活卡
  userOpenid(params) {
    return http.post('user-openid', params);
  }, //获取用户当前客户端openid
  userVipPay(params) {
    return http.post('user-vip-pay', params);
  }, //线上支付激活
  userShareCode(params) {
    return http.post('user-share-code', params);
  }, //查看推广码
  userShareApply(params) {
    return http.post('user-share-apply', params);
  }, //申请推广码
  userWithdrawApply(params) {
    return http.post('user-withdraw-apply', params);
  }, //提现申请
  userWithdrawRecord(params) {
    return http.post('user-withdraw-record', params);
  }, //提现记录
  rule(params) {
    return http.post('user-withdraw-rule', params);
  }, //提现记录
  schoolScoreForecast(params) {
    return http.post('school-score-forecast', params);
  }, //提现记录
  getareaList(params) {
    return http.get('area-list', params);
  }, //获取地区下拉列表
  about(params) {
    return http.get('about', params);
  }, //获取地区下拉列表
  newsList(params) {
    return http.post('news-list', params);
  }, //获取地区下拉列表
  videoList(params) {
    return http.post('video-list', params);
  }, //获取地区下拉列表
  stationNearby(params) {
    return http.post('station-nearby', params);
  }, //获取附近站点
  stationAppointRecord(params) {
    return http.post('station-appoint-record', params);
  }, //获取附近站点
  stationAppointApply(params) {
    return http.post('station-appoint-apply', params);
  }, //获取附近站点
  stationTeacherList(params) {
    return http.post('station-teacher-list', params);
  }, //获取附近站点
  stationTeacherDetail(params) {
    return http.post('station-teacher-detail', params);
  }, //获取附近站点
  stationCasesDetail(params) {
    return http.post('station-cases-detail', params);
  }, //获取附近站点
  teacherApply(params) {
    return http.post('teacher-apply', params);
  }, //高报师/代理商申请
  payDirect(params) {
    return http.get('pay-direct', params);
  }, //直接支付获取信息
  weixinPay(params) {
    return http.post('pay-direct', params);
  }, //直接支付预支付
  getOptions(params) {
    return http.get('school-enroll-plan', params);
  }, //直接支付获取信息
  schoolEnrollPlan(params) {
    return http.post('school-enroll-plan', params);
  }, //直接支付预支付
  careerTypeList(params) {
    return http.post('career-type-list', params);
  }, //职业分类
  careerList(params) {
    return http.post('career-list', params);
  }, //职业列表（分类内）
  careerDetail(params) {
    return http.post('career-detail', params);
  }, //职业详情
  schoolMark(params) {
    return http.post('school-mark', params);
  }, //关注（收藏）学校
  customSchoolSearchByCode(params) {
    return http.post('custom-school-search-by-code', params);
  }, //关注（收藏）学校
  customMajorSearchByCode(params) {
    return http.post('custom-major-search-by-code', params);
  }, //关注（收藏）学校
}



// WEBPACK FOOTER //
// ./src/request/apiList.js